<!------------------------------------------------------------------------------
- Copyright (c) 2019. BMW Group. All rights reserved.
----------------------------------------------------------------------------->

<div class="generic-modal"
  data-cy="modal">
  <div [class]="headerClass" data-cy="generic-modal-header">
    <p class="generic-modal-title"
    data-cy="modal-title">{{title}}</p>
    <button (click)="clickCloseButton()"
      [disabled]="loading"
      class="close"
      data-cy="modal-close-button"
    type="button"></button>
  </div>

  <div class="generic-modal-body">
    <ng-content></ng-content>
  </div>

  <div class="generic-modal-footer"
    data-cy="modal-footer">
    @if (secondaryActionTitle) {
      <button (click)="clickSecondaryButton()"
        [disabled]="disableSecondaryButton"
        class="btn-secondary"
        data-cy="modal-secondary-button"
      type="button">{{secondaryActionTitle}}</button>
    }
    @if (primaryActionTitle) {
      <div class="generic-modal-primary-button-container">
        <button (click)="clickPrimaryButton()"
          [class]="primaryButtonClass"
          [disabled]="disablePrimaryButton"
          data-cy="modal-primary-button"
        type="button">{{primaryActionTitle}}</button>
        @if (loading) {
          <app-loading-spinner class="button-spinner"></app-loading-spinner>
        }
      </div>
    }
  </div>
</div>
